import { render, staticRenderFns } from "./BoxList.vue?vue&type=template&id=7dc1cd46&scoped=true&"
import script from "./BoxList.vue?vue&type=script&lang=js&"
export * from "./BoxList.vue?vue&type=script&lang=js&"
import style0 from "./BoxList.vue?vue&type=style&index=0&id=7dc1cd46&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dc1cd46",
  null
  
)

export default component.exports